/**
 * assets/av-akkoord-popup.js
 * Gedrag van snippets/av-akkoord-popup.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

(function(){
  if (window.__avTermsLazy) return;
  window.__avTermsLazy = true;
  var TERMS_URL = '/policies/terms-of-service';
  var loaded = false, loading = false;
  function target(){
    return document.querySelector('[data-bottom-sheet-content="av-akkoord-sheet"] [data-av-terms-body]')
        || document.querySelector('[data-bottom-sheet-content="av-akkoord-sheet"]');
  }
  function showLink(t){
    if (!t) return;
    t.innerHTML = '<p style="font-size:0.95rem;line-height:1.5;">Lees de volledige <a href="' + TERMS_URL + '" target="_blank" rel="noopener" style="color:#0f766e;text-decoration:underline;font-weight:600;">algemene voorwaarden</a>.</p>';
  }
  function load(){
    if (loaded || loading) return;
    loading = true;
    fetch(TERMS_URL, { headers: { 'Accept': 'text/html' }, credentials: 'same-origin' })
      .then(function(r){ if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
      .then(function(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector('.shopify-policy__body')
              || doc.querySelector('.shopify-policy__container .rte')
              || doc.querySelector('main .rte')
              || doc.querySelector('.rte')
              || doc.querySelector('main');
        var t = target();
        if (t && el && el.textContent.trim().length > 40){
          t.innerHTML = el.innerHTML;
          loaded = true;
        } else {
          showLink(t);
        }
      })
      .catch(function(){ showLink(target()); })
      .then(function(){ loading = false; });
  }
  document.addEventListener('click', function(e){
    var trg = e.target && e.target.closest && e.target.closest('[data-av-akkoord-trigger]');
    if (trg) load();
  }, true);
})();

(function() {
  if (window.__avAkkoordLogic) return;
  window.__avAkkoordLogic = true;

  /* Intent-recovery state*/
  const INTENT = { pendingBtn: null, pendingTime: 0 };
  const INTENT_TTL_MS = 60000; /* 60 sec, daarna verloopt intent*/

  const $$ = (s) => Array.from(document.querySelectorAll(s));
  const getCheckboxes = () => $$('[data-av-akkoord-checkbox]');
  const getCheckoutBtns = () => $$('[data-av-akkoord-checkout-btn]');
  const isAccepted = () => { const cbs = getCheckboxes(); return cbs.length > 0 && cbs.some(c => c.checked); };

  /* Meetpunten (26-10-2026, work item #77, project Design en UX 2027).
     Als GA4-event via gtag: dat gaat over data.vijvercentrum.nl naar GA4. Een
     los object in de dataLayer (zoals tot 27-10) kwam nergens aan: gtag.js leest
     alleen gtag-aanroepen, en de Amplitude-SDK van het thema staat sinds
     14-10-2026 uit (PR #243). Zonder gtag (tests) blijft het object-patroon.
     Een meetfout mag de klant nooit raken, vandaar de try. */
  const meld = (event, data) => {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', event, data || {});
      else { window.dataLayer = window.dataLayer || []; window.dataLayer.push(Object.assign({ event: event }, data || {})); }
    } catch (_) {}
  };
  const DOOR_SLEUTEL = 'vc_av_doorgestuurd_op';
  const merkDoorgang = () => { try { sessionStorage.setItem(DOOR_SLEUTEL, String(Date.now())); } catch (_) {} };
  /* Eén plek voor de navigatie, zodat de test die kan opvangen. */
  const gaNaar = (url) => { (window.__avGaNaar || ((u) => { window.location.href = u; }))(url); };

  function updateButtons() {
    /* GOAT-UX: Knop NIET disabled (per Smashing/Baymard research).*/
    /* Knop blijft klikbaar - intercept handler vangt unchecked submit op.*/
    /* Wrappers krijgen wel een 'checked'-state-class voor visuele feedback.*/
    const accepted = isAccepted();
    document.querySelectorAll('[data-av-akkoord-wrapper]').forEach(w => {
      w.classList.toggle('av-akkoord-checked', accepted);
      w.classList.remove('av-akkoord-pulse');
    });
    /* HERSTELD 20-07-2026: knop weer grijs tot akkoord, oranje zodra aangevinkt.*/
    /* Tussen 18-05 en 20-07 maakte dit blok de knop ONVOORWAARDELIJK actief, ook*/
    /* zonder vinkje (GOAT-UX 'nooit disabled'). Daarmee verdween de grijs-naar-oranje*/
    /* overgang die de klant vertelt wat er van hem gevraagd wordt.*/
    /* FIX 24-07-2026: pointer-events-none is eruit gehaald. Met die class kwam*/
    /* een klik nooit bij de intercept-handler aan: de klant klikte op Afrekenen*/
    /* en er gebeurde letterlijk niets, geen uitleg, geen foutmelding. De knop*/
    /* blijft nu visueel gedempt (opacity) maar klikbaar, zodat de handler kan*/
    /* zeggen dat het vinkje nog aan moet. Sinds 20-07, toen deze class*/
    /* terugkwam, zakte de conversie van 4,43 naar 3,23 procent.*/
    /* 26-10-2026 (#77): de wachtstand is een grijze knop met donkere tekst
       (leisteen-700 op leisteen-200, 8,4:1) in plaats van wit op 50 procent
       oranje (2,2:1). De knop blijft klikbaar en geeft dan uitleg, dus de
       contrasteis geldt (WCAG 1.4.3). aria-disabled is weg: een schermlezer
       meldde de knop als niet beschikbaar, terwijl hij juist uitleg geeft. De
       klik-handler hieronder blijft de enige poort; de knop is nooit echt
       disabled (FIX 24-07-2026: een disabled button ontvangt geen klik). */
    const WACHT = ['bg-slate-200', 'text-slate-700'];
    const KLAAR = ['bg-koi', 'text-white', 'shadow-md', 'hover:bg-orange-800', 'hover:shadow-lg'];
    getCheckoutBtns().forEach(btn => {
      if (btn.tagName !== 'A') btn.disabled = false;
      btn.classList.remove('opacity-50', 'cursor-not-allowed');
      btn.removeAttribute('aria-disabled');
      WACHT.forEach(c => btn.classList.toggle(c, !accepted));
      KLAAR.forEach(c => btn.classList.toggle(c, accepted));
    });
  }

  document.addEventListener('change', (e) => {
    const cb = e.target.closest('[data-av-akkoord-checkbox]');
    if (!cb) return;
    getCheckboxes().forEach(c => { if (c !== cb) c.checked = cb.checked; });
    $$('[data-av-akkoord-error]').forEach(el => el.style.display = cb.checked ? 'none' : '');
    updateButtons();
    const wrapEl = cb.closest('[data-av-akkoord-wrapper]');
    const scope = (wrapEl && wrapEl.getAttribute('data-av-scope')) || 'onbekend';
    /* Audittrail: leg het akkoord vast in winkelwagen-attributen. Sinds
       26-10-2026 (#77) ook welke versie van de voorwaarden (vingerafdruk van de
       tekst) en waar het akkoord is gegeven. Bij uitvinken worden ze leeg-
       gemaakt, zodat er geen oud akkoord blijft staan; een leeg attribuut
       verwijdert het bij Shopify. */
    const bewaar = fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: cb.checked ? {
        'terms_accepted_at': new Date().toISOString(),
        'terms_version': (wrapEl && wrapEl.getAttribute('data-av-versie')) || '',
        'terms_scope': scope
      } : { 'terms_accepted_at': '', 'terms_version': '', 'terms_scope': '' } })
    }).catch(() => {});
    if (!cb.checked) return;
    /* HERSTELD 20-07-2026: automatisch doorgaan zodra de klant aanvinkt.*/
    /* Voorheen gebeurde dit alleen als de klant EERST op de afrekenknop had geklikt*/
    /* (intent-recovery). In de drawer kon dat niet eens, want die knop stond op*/
    /* pointer-events-none. Nu: vinkje aan is het startsein, ongeacht de volgorde.*/
    /* Alleen bij een echte gebruikersactie: programmatisch zetten van .checked*/
    /* vuurt geen change-event, dus dit pad is niet automatisch te triggeren.*/
    const intentAge = Date.now() - INTENT.pendingTime;
    const hadIntent = INTENT.pendingBtn && document.body.contains(INTENT.pendingBtn) && intentAge < INTENT_TTL_MS;
    meld('av_akkoord_aangevinkt', { av_scope: scope, had_intentie: !!hadIntent });
    const scopeEl = cb.closest('form, [data-cart-panel], section, main, body');
    const intentBtn = hadIntent
      ? INTENT.pendingBtn
      : ((scopeEl && scopeEl.querySelector('[data-av-akkoord-checkout-btn]')) || document.querySelector('[data-av-akkoord-checkout-btn]'));
    if (intentBtn && document.body.contains(intentBtn)) {
      /* Reset intent*/
      INTENT.pendingBtn = null;
      INTENT.pendingTime = 0;
      /* FIX 24-07-2026: bestemming NU vastleggen, niet pas over 550 ms.*/
      /* Het aanvinken schrijft terms_accepted_at weg via /cart/update.js, en*/
      /* een cart-refresh vervangt daarna de hele drawer-HTML. De knop waar*/
      /* intentBtn naar wees bestaat dan niet meer, waardoor de navigatie*/
      /* stilletjes werd overgeslagen en het vinkje terugsprong naar uit.*/
      /* Dat is precies wat klanten meldden. Door href en form vooraf te*/
      /* bewaren overleeft de doorgang die vervanging.*/
      const doelHref = (intentBtn.tagName === 'A' && intentBtn.href) ? intentBtn.href : null;
      const doelForm = intentBtn.form || null;
      /* Visuele feedback op de checkbox-wrapper*/
      const wrap = cb.closest('[data-av-akkoord-wrapper]');
      const helper = wrap && wrap.querySelector('[id$="-help"]');
      const origHelper = helper && helper.textContent;
      if (helper) {
        helper.style.color = '#0f766e'; /* 26-10-2026: was #0d9488 (3,6:1), nu 5,3:1 */
        helper.style.fontWeight = '600';
        helper.innerHTML = '&#10003; Akkoord ontvangen, je gaat door naar de betaling.';
      }
      /* Subtiele success-pulse op de Afrekenen-knop*/
      intentBtn.style.transition = 'box-shadow 0.4s ease, transform 0.2s ease';
      intentBtn.style.boxShadow = '0 0 0 4px rgba(13, 148, 136, 0.35)';
      intentBtn.style.transform = 'scale(1.02)';
      /* Wacht ~500ms zodat klant de feedback ziet, dan doorgaan*/
      /* 26-10-2026 (#77): wacht tot het akkoord in de winkelwagen staat, hooguit
         1,5 seconde, zodat de audittrail niet wegvalt door het doorgaan. */
      const wacht = (ms) => new Promise(r => setTimeout(r, ms));
      Promise.all([wacht(550), Promise.race([bewaar, wacht(1500)])]).then(() => {
        meld('av_akkoord_doorgestuurd', { av_scope: scope });
        merkDoorgang();
        intentBtn.style.boxShadow = '';
        intentBtn.style.transform = '';
        if (helper && origHelper) {
          helper.textContent = origHelper;
          helper.style.color = '';
          helper.style.fontWeight = '';
        }
        /* Trigger de checkout-actie op de vooraf bewaarde bestemming, zodat een*/
        /* tussentijdse cart-refresh de doorgang niet meer kan blokkeren.*/
        if (doelHref) {
          gaNaar(doelHref);
        } else if (doelForm) {
          /* FIX 24-07-2026 (tweede ronde): form.submit() laat de naam van de*/
          /* submitknop vallen. De knop op de winkelwagenpagina heet*/
          /* name="checkout"; zonder die naam leest Shopify de post als een*/
          /* gewone winkelwagen-update en stuurt hij je terug naar /cart. De*/
          /* klant zag de pagina verversen en verder gebeurde er niets.*/
          /* requestSubmit neemt de knop wel mee, zodat zowel de aantallen*/
          /* (updates[]) als het doorgaan-signaal meegaan.*/
          if (typeof doelForm.requestSubmit === 'function' && document.body.contains(intentBtn)) {
            doelForm.requestSubmit(intentBtn);
          } else {
            /* Oudere browsers: geef het doorgaan-signaal als verborgen veld mee.*/
            let sein = doelForm.querySelector('input[type="hidden"][name="checkout"]');
            if (!sein) {
              sein = document.createElement('input');
              sein.type = 'hidden';
              sein.name = 'checkout';
              sein.value = '';
              doelForm.appendChild(sein);
            }
            doelForm.submit();
          }
        } else if (document.body.contains(intentBtn)) {
          intentBtn.click();
        } else {
          /* Laatste vangnet: knop is uit de DOM verdwenen, val terug op de*/
          /* standaard-checkout in plaats van de klant te laten stranden.*/
          gaNaar('/checkout');
        }
      });
    }
  });

  /* Intercept checkout-klik wanneer NOG niet akkoord: scroll + pulse + error + auto-focus*/
  /* Plus: bewaar INTENT zodat we automatisch kunnen doorgaan zodra klant alsnog vinkt*/
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-av-akkoord-checkout-btn]');
    if (!btn || isAccepted()) return;
    e.preventDefault();
    e.stopPropagation();
    /* Bewaar intent: welke knop wilde de klant aanklikken?*/
    INTENT.pendingBtn = btn;
    INTENT.pendingTime = Date.now();
    /* Vind de checkbox-wrapper die het dichtst bij de geklikte knop staat*/
    const sibling = btn.closest('form, [data-cart-panel], section, main, body');
    const wrap = (sibling && sibling.querySelector('[data-av-akkoord-wrapper]')) || document.querySelector('[data-av-akkoord-wrapper]');
    if (!wrap) return;
    meld('av_akkoord_klik_zonder_vinkje', { av_scope: wrap.getAttribute('data-av-scope') || 'onbekend' });
    const cb = wrap.querySelector('[data-av-akkoord-checkbox]');
    const err = wrap.querySelector('[data-av-akkoord-error]');
    /* Pulse-animatie + scroll naar checkbox*/
    wrap.classList.remove('av-akkoord-pulse');
    void wrap.offsetWidth; /* restart animatie*/
    wrap.classList.add('av-akkoord-pulse');
    wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
    if (err) err.style.display = '';
    setTimeout(() => { if (cb) cb.focus({preventScroll: true}); }, 500);
    setTimeout(() => wrap.classList.remove('av-akkoord-pulse'), 3000);
  }, true);

  document.addEventListener('submit', (e) => {
    if (e.submitter && e.submitter.matches && e.submitter.matches('[data-av-akkoord-checkout-btn]') && !isAccepted()) {
      e.preventDefault();
    }
  }, true);

  /* Terug uit de checkout binnen 30 seconden na het automatisch doorgaan.
     Toetst de hypothese uit het onderzoek B-01 (25-10-2026) dat het vinkje een
     deel van de klanten te vroeg naar de checkout stuurt. Draait op elke pagina,
     ook zonder vinkje, want de klant komt overal terug. */
  function meetTerugkeer() {
    let t = null;
    try {
      t = sessionStorage.getItem(DOOR_SLEUTEL);
      if (t) sessionStorage.removeItem(DOOR_SLEUTEL);
    } catch (_) { return; }
    if (!t) return;
    const sec = Math.round((Date.now() - Number(t)) / 1000);
    if (sec >= 0 && sec <= 30) meld('av_akkoord_terug_uit_checkout', { seconden: sec });
  }
  meetTerugkeer();
  window.addEventListener('pageshow', (e) => { if (e.persisted) meetTerugkeer(); });

  function init() {
    /* FIX 18 mei: skip op pagina's zonder checkbox (homepage, product, blog, etc.)*/
    /* Voorheen breakte fetch('/cart.js') de GA4 engagement-timer en daarmee Smart Bidding signaal.*/
    /* AV-akkoord blijft 100% Thuiswinkel-compliant, checkbox bestaat alleen op cart/checkout pages*/
    /* en daar wordt init() opnieuw aangeroepen.*/
    const checkboxes = getCheckboxes();
    if (!checkboxes || checkboxes.length === 0) return;
    updateButtons();
    /* BEWUST GEEN pre-check meer (20-07-2026, kaart Audit B1).*/
    /* Hier werd /cart.js opgehaald en het vinkje automatisch aangezet zodra het*/
    /* cart-attribute terms_accepted_at bestond. Gevolg: zodra een klant een keer*/
    /* akkoord had gegeven, stond het vinkje bij elk volgend bezoek aan winkelwagen*/
    /* en drawer al aan. Dat is in strijd met de ICTRecht-eis waarop de Thuiswinkel-*/
    /* certificering is verleend: onaangevinkt default, verplicht aanvinken.*/
    /* Instemmen moet elke keer een bewuste handeling van de klant zijn.*/
    /* Het wegschrijven van terms_accepted_at blijft staan, dat is de audittrail.*/
  }
  /* FIX 24-07-2026: de cart-drawer vervangt bij elke refresh zijn complete*/
  /* innerHTML (aantal wijzigen, cross-sell toevoegen). De verse HTML draagt de*/
  /* knop weer in de gedempte staat, terwijl updateButtons() daarna nooit werd*/
  /* aangeroepen. Deze observer zorgt dat de knopstaat altijd klopt met de*/
  /* checkbox. Het vinkje zelf wordt bewust NIET automatisch teruggezet: dat*/
  /* moet een bewuste handeling blijven (ICTRecht-eis, Thuiswinkel).*/
  function bewaakDom() {
    if (!('MutationObserver' in window)) return;
    let gepland = false;
    const obs = new MutationObserver(() => {
      if (gepland) return;
      gepland = true;
      requestAnimationFrame(() => {
        gepland = false;
        if (getCheckboxes().length) updateButtons();
      });
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => { init(); bewaakDom(); });
  } else {
    init();
    bewaakDom();
  }
})();
